import { Typography, IconButton, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { removeEntry, updateFoodEntry } from "../../store/todaySlice";

import { colors, space, radius, borders, fontWeight, fontSize } from "../../design/tokens";

import {
  Card,
  TextInput,
  Button,
  Text,
  Row
} from "../layout";

import { IconTrash } from "@tabler/icons-react";

export default function TodayFoodEntryCard({
  entry,
  foodsById
}) {

  const dispatch = useDispatch();

  const food = foodsById[entry.foodId];
  if (!food) return null;

  // const grams = entry.portions?.[entry.foodId] || 100;
  // const grams = entry.portions?.[entry.foodId];
  const grams = entry.portions?.[entry.foodId] ?? 100;
  const gramsForCalc = Number(entry.portions?.[entry.foodId] || 0);
    // const grams = entry.portions?.[entry.foodId] || 0;

  return (
    <Card 
      style={{ 
        borderBottom: `${borders.sm} ${colors.primary}` ,
        borderRadius:"0 !important",
        padding:"0px 0px 5px"      
        }}>
    
      <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>

        <Text variant="p" style={{
          fontWeight: `${fontWeight.semibold}`, 
          fontSize: `${fontSize.xs}`}}>
          {food.name}
        </Text>

        <Button
          onClick={() => dispatch(removeEntry(entry.id))}
          style={{
            padding:"0px",
            // background:"none",
            borderRadius:"0px"
          }}
        >
            <IconTrash style={{width:"18px", height: "18px"}}/>
        </Button>



      </Row>
      <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%", marginTop: "10px "}}>
        <Text variant="p" style={{
          fontWeight: `${fontWeight.regular}`, 
          fontSize: `${fontSize.xs}`}}>
          {grams}g — {((food.calories * gramsForCalc) / 100).toFixed(0)} kcal
        </Text>

        <TextInput
          type="number"
          value={grams}
          onChange={(e) =>
            dispatch(updateFoodEntry({
              entryId: entry.id,
              foodId: entry.foodId,
              // grams: Number(e.target.value)
              grams: e.target.value === "" ? "" : Number(e.target.value)
            }))
          }
          slim

          style={{
            padding: "10px",
            borderRadius: "10px",
            width: "100px",
            fontSize: "16px",
            lineHeight: "1.1",
            textAlign: "right",
            border: "1px solid #000",
          }}
        />
      </Row>
    </Card>
  );
}